import { Listing } from 'types';

import { formatPrice } from './formatPrice';

export const getListingStrikethroughPrice = (listing: Listing) =>
  listing?.strikethroughPriceCents && listing.activePricingModel !== 'AUCTION'
    ? formatPrice(listing.strikethroughPriceCents)
    : null;
